import { supabase } from "@/lib/supabaseClient";

export type LogAction = "created" | "updated" | "deleted";
export type LogEntity = "client" | "contract" | "payment" | "job";

interface LogParams {
  tenantId: string;
  action: LogAction;
  entity: LogEntity;
  entityId?: string;
  entityName?: string;
}

export async function logActivity({ tenantId, action, entity, entityId, entityName }: LogParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("activity_logs").insert({
      tenant_id: tenantId,
      user_id: user?.id ?? null,
      action,
      entity,
      entity_id: entityId ?? null,
      entity_name: entityName ?? null,
    });
  } catch {
    // Silent fail — logs are non-critical
  }
}
